import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Badge, Button, Col, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Modal, ModalBody, Spinner, UncontrolledDropdown } from 'reactstrap';
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon, RSelect } from '../../../../components/Component';
import ReactDataTable from './ReactDataTable/ReactDataTable';
import { WEBSITE_BASE_URL } from '../../../../config';
import ToastExample from '../../../../helpers/toast';
import Content from '../../../../layout/content/Content';
import Head from '../../../../layout/head/Head';
import { createItemGroup, deleteGroup, getAllItemGroups, linkItemGroupStore, toggleGroup, updateItemGroup } from '../../../../redux/admin/item/action';
import { getAllStoreCategories } from '../../../../redux/admin/store/action';
import { nonActiveFormSubmissionStatus, openFormLoading } from '../../../../redux/common/actions';
import * as yup from "yup";
import noimage from '../../../../assets/images/noimage.png'
import { Image, Table } from 'antd';
import { ColorRing } from 'react-loader-spinner';

const ItemGroups = () => {
    const dispatch = useDispatch(); //defining dispatch

    //function to get data from backend
    useEffect(() => {
        dispatch(getAllStoreCategories());
        dispatch(getAllItemGroups()).then((response) => {
            if (response.payload.length > 0) {
                setLoading(false)
            }
        })
    }, []);

    //to store data from application state to a constant
    const getSelectors = (state) => ({
        item_groups: state.item.item_groups,
        store_categories: state.store.store_categories,
        form_loading: state.common.form_loading,
        form_submission_status: state.common.form_submission_status,
    });
    const { item_groups, store_categories, form_loading, form_submission_status, } = useSelector(getSelectors);
    const [loading, setLoading] = useState(true);

    const [editingGroup, setEditingGroup] = useState([]);   //edit state

    const [deletingGroup, setDeletingGroup] = useState([]);   //delete state

    const [linkingGroup, setLinkingGroup] = useState([]);   //link state

    const [formData, setFormData] = useState([]);   //form data state defined

    const [showToast, setShowToast] = useState(false);   //toast state
    const [image, setImage] = useState([]);  // state defined
    const [backgroundImage, setBackgroundImage] = useState([]);  // state defined

    const [data, setData] = useState([]);  //data state defined

    const [stores, setStores] = useState();  //stores state defined
    const [selectedStores, setSelectedStores] = useState();  //stores state defined
    const [itemGroupTableDatas, setItemGroupTableDatas] = useState();  //stores state defined


    //modal state
    const [modal, setModal] = useState({
        edit: false,
        add: false,
        delete: false,
        link: false
    });

    //to open add modal
    const openAddModal = () => {
        setEditingGroup([]);
        setImage(null);
        setBackgroundImage(null);
        dispatch(nonActiveFormSubmissionStatus());
        setTimeout(() => {
            setModal({ add: true });
        }, 100);
    };

    //to open edit modal
    const openEditModal = (group) => {
        setModal({ edit: true });
        dispatch(nonActiveFormSubmissionStatus());
        setImage(null);
        setBackgroundImage(null);
        setEditingGroup(group);
    };

    const storelinks = store_categories?.find((s) => s.id == linkingGroup.store_category_id)?.stores?.map((s) => (
        { value: s.id, label: s.name }
    ));

    const storelinkdefault = linkingGroup?.stores?.map((s) => (
        { value: s.id, label: s.name }
    ));

    //to open link modal
    const openLinkModal = (group) => {
        setModal({ link: true });
        dispatch(nonActiveFormSubmissionStatus());
        setImage(null);
        setBackgroundImage(null);
        setLinkingGroup(group);
        setSelectedStores(group?.stores?.map((s) => ({ value: s.id, label: s.name })))
    };

    //to open delete modal
    const openDeleteModal = (group) => {
        setModal({ delete: true });
        dispatch(nonActiveFormSubmissionStatus());
        setDeletingGroup(group);
    };

    //to close modal
    const onFormCancel = () => {
        setModal({ edit: false, add: false, delete: false, link: false });
        document.getElementByClass("invalid").innerHTML = "";
        resetForm();
        setSelectedStores('')
    };

    // to reset the form
    const resetForm = () => {
        setFormData({
            name: "",
            description: "",
            store_category_id: "",
        });
    };

    const listStoreCategories = store_categories?.map((category) => (
        { value: category.id, label: category.name }

    ));

    const handleChange = (val) => {
        var options = val;
        setSelectedStores(options);
    }

    const defaultValues = useMemo(
        () => ({
            id: editingGroup?.id || "",
            name: editingGroup?.name || "",
            description: editingGroup?.description || "",
            store_category_id: editingGroup?.store_category_id || "",
        }),
        [editingGroup]
    );

    const groupSchema = yup.object({
        name: yup.string().required(),
        store_category_id: yup.string().required(),
    });

    //form methods
    const methods = useForm({
        resolver: yupResolver(groupSchema),
        defaultValues: defaultValues,
    });

    //useform methods
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        control
    } = methods;

    const linkStoreSubmit = () => {
        dispatch(openFormLoading());
        const data = new FormData();
        data.append('id', linkingGroup?.id);
        if (selectedStores?.length > 0) {
            var values = selectedStores?.map((s) => (s.value))
            console.log(values, 'valuess');
            data.append('store_id', JSON.stringify(values));
        }
        dispatch(linkItemGroupStore(data));
    }

    //submit function
    const onFormSubmit = (submitData) => {
        dispatch(openFormLoading());
        console.log(submitData, 'submitdata');
        const new_data = new FormData();
        new_data.append('id', editingGroup?.id);
        new_data.append('name', submitData?.name);
        new_data.append('store_category_id', submitData?.store_category_id);
        if (image) {
            new_data.append('image', image);
        }
        if (backgroundImage) {
            new_data.append('background_image', backgroundImage);
        }
        if (modal.edit) {
            setTimeout(() => {
                dispatch(updateItemGroup(new_data));
            }, 50);
        } else if (modal.add) {
            dispatch(createItemGroup(new_data));
        } else if (modal.delete) {
            dispatch(deleteGroup(deletingGroup?.id));
        }
        resetForm();
    };

    // toggle
    const handleStatus = (e, id) => {
        dispatch(toggleGroup(id));
        setTimeout(() => {
            dispatch(getAllItemGroups());
            setShowToast(true);
        }, 500);

        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    };

    const dataTableColumns = [
        {
            name: "Title",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Store Category",
            selector: (row) => row.store_category?.name,
            sortable: true,
        },
        {
            name: "Image",
            selector: (row) => row.image,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <Image
                        style={{
                            height: "15vh",
                            width: "15vh",
                            objectFit: 'cover',
                        }}
                        src={row?.image ? row?.image : noimage}
                    />
                </div>
            )
        },
        {
            name: "Background Image",
            selector: (row) => row.background_image,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <Image
                        style={{
                            height: "15vh",
                            width: "15vh",
                            objectFit: 'cover',
                        }}
                        src={row?.background_image ? row?.background_image : noimage}
                    />
                </div>
            )
        },
        {
            name: "Status",
            selector: (row) => row.startDate,
            cell: (row) => (
                <Button color={row?.is_active ? "success" : "danger"} onClick={(e) => {
                    handleStatus(e, row?.id)
                }}>
                    {row?.is_active ? <Icon name="stop-circle-fill" /> : <Icon name="play-circle-fill" />}
                </Button>
            )
        },
        {
            name: "Action",
            selector: (row) => row.salary,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <DropdownTrans row={row} />
                </div>
            )
        },
    ];



    //action dropdown
    const DropdownTrans = ({ row }) => {
        return (
            <UncontrolledDropdown>
                <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
                    <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                    <ul className="link-list-plain">
                        <li>
                            <DropdownItem tag="a" onClick={() => openEditModal(row)}>
                                <Icon name="pen" />Edit
                            </DropdownItem>
                        </li>
                        <li>
                            <DropdownItem tag="a" onClick={() => openLinkModal(row)}>
                                <Icon name="link" />Link Stores
                            </DropdownItem>
                        </li>
                        <li>
                            <DropdownItem tag="a"
                                href="#dropdownitem"
                                onClick={() => openDeleteModal(row)}>
                                <Icon name="trash" />Delete
                            </DropdownItem>
                        </li>
                    </ul>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    };

    //submit toast
    useEffect(() => {
        if (modal.add == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllItemGroups());
                setData(item_groups);
                setModal({ add: false });
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }

        if (modal.edit == true && editingGroup && form_loading == false && form_submission_status == true) {
            dispatch(getAllItemGroups());
            setData(item_groups);
            setModal({ edit: false });
            setShowToast(true);
            reset(defaultValues);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        } else {
            reset(defaultValues);
        }

        if (modal.delete == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllItemGroups());
                setData(item_groups);
                setModal({ delete: false });
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }

        if (modal.link == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllItemGroups());
                setData(item_groups);
                setModal({ link: false });
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }
    }, [createItemGroup, form_loading, modal, form_submission_status]);


    return (
        <React.Fragment>
            {loading ? (
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
            ) :
                <React.Fragment>
                    <Head title="Item Groups"></Head>

                    {/* content */}
                    <Content>
                        <BlockHead size="sm">
                            <BlockBetween>
                                <BlockHeadContent>
                                    <BlockTitle tag="h3" page>
                                        Item Group Lists
                                    </BlockTitle>
                                    <BlockDes className="text-soft">
                                        <p>You have total {item_groups?.length} item groups.</p>
                                    </BlockDes>
                                </BlockHeadContent>
                                <BlockHeadContent>
                                    <div className="toggle-wrap nk-block-tools-toggle">
                                        <ToastExample
                                            show={showToast}
                                        />
                                        <div className="toggle-expand-content">
                                            <ul className="nk-block-tools g-3">
                                                {/* <li>
                      <a
                        href="#export"
                        onClick={(ev) => {
                          ev.preventDefault();
                        }}
                        className="btn btn-white btn-outline-light"
                      >
                        <Icon name="download-cloud"></Icon>
                        <span>Export</span>
                      </a>
                    </li> */}
                                                <li className="nk-block-tools-opt">
                                                    <Button color="primary" className="btn-icon"
                                                        onClick={() => openAddModal()}
                                                    >
                                                        <Icon name="plus"></Icon>
                                                    </Button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </BlockHeadContent>
                            </BlockBetween>
                        </BlockHead>
                        <ReactDataTable data={item_groups} columns={dataTableColumns} expandableRows pagination />
                    </Content>

                    {/* add and edit modal */}
                    <Modal
                        isOpen={modal.add || modal.edit}
                        toggle={() => setModal({ add: false })}
                        className="modal-dialog-centered"
                        size="lg"
                    >
                        <ModalBody>
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">
                                    {modal.edit ? "Editing Group - " + editingGroup?.name : "Add Item Group"}
                                </h5>
                                <div className="mt-4">
                                    <Form className="row gy-4"
                                        onSubmit={handleSubmit(onFormSubmit)}
                                        encType="multipart/formData">
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Title</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="name"
                                                    placeholder="Enter Title"
                                                    ref={register({ required: "This field is required" })}
                                                />
                                                {errors.name && <span className="invalid">{errors.name.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Store Category</label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="store_category_id"
                                                        control={control}
                                                        render={({ onChange, value, ref }) => (
                                                            <RSelect
                                                                options={listStoreCategories}
                                                                onChange={(val) => {
                                                                    onChange(val.value);
                                                                }}
                                                                defaultValue={listStoreCategories.find((cat) => cat.value === value)}
                                                            />
                                                        )}
                                                    />
                                                    {errors.store_id && (
                                                        <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a Category</span>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        {/* <Col md="12" style={modal.edit ? { display: 'block' } : { display: 'none' }}>
                  <FormGroup>
                    <label className="form-label">Stores</label>
                    <div className="form-control-wrap">
                      <Controller
                        name="store_id"
                        control={control}
                        render={({ onChange, value, ref }) => (
                          <RSelect
                            id='storeid'
                            options={stores}
                            onChange={(val) => handleChange(val)}
                            isMulti
                            defaultValue={stores?.map((s) => s.value)?.includes(editingGroup?.stores?.map((s) => s.id))}
                          />
                        )}
                      />
                      {errors.store_id && (
                        <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a Category</span>
                      )}
                    </div>
                  </FormGroup>
                </Col> */}
                                        <Col md="6" style={modal.edit ? { display: 'block' } : { display: 'none' }}>
                                            <FormGroup>
                                                <label className="form-label">Current Image </label>
                                                <div className="my-2" id={editingGroup.id}>
                                                    {editingGroup?.image ?
                                                        <Image
                                                            style={{
                                                                objectFit: 'cover', height: '20vh'
                                                            }}
                                                            src={editingGroup?.image}
                                                        />
                                                        :
                                                        <>
                                                            <img src={noimage} alt="item GreditingGroup" style={{ height: '7vh', width: '7vh' }} />
                                                            <span className='m-1' style={{ color: '#330033', fontSize: '9px' }}>No image found</span>
                                                        </>
                                                    }
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6" style={modal.edit ? { display: 'block' } : { display: 'none' }}>
                                            <FormGroup>
                                                <label className="form-label">Current Background Image </label>
                                                <div className="my-2" id={editingGroup.id}>
                                                    {editingGroup?.background_image ?
                                                        <Image
                                                            style={{
                                                                objectFit: 'cover', height: '20vh'
                                                            }}
                                                            src={editingGroup?.background_image}
                                                        />
                                                        :
                                                        <>
                                                            <img src={noimage} alt="item GeditingGroup" style={{ height: '7vh', width: '7vh' }} />
                                                            <span className='m-1' style={{ color: '#330033', fontSize: '9px' }}>No image found</span>
                                                        </>
                                                    }
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Image </label>
                                                <input
                                                    className="form-control"
                                                    type="file"
                                                    name="image"
                                                    accept="image/png, image/jpeg, image/jpg"
                                                    onChange={(e) => {
                                                        setImage(e.target.files[0])
                                                    }}
                                                />
                                                {errors.image && <span className="invalid">{errors.image.message}</span>}
                                                {/* <FormText>upload resolution 1200x1200 pixel</FormText> */}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Background Image </label>
                                                <input
                                                    className="form-control"
                                                    type="file"
                                                    name="background_image"
                                                    accept="image/png, image/jpeg, image/jpg"
                                                    onChange={(e) => {
                                                        setBackgroundImage(e.target.files[0])
                                                    }}
                                                />
                                                {errors.background_image && <span className="invalid">{errors.background_image.message}</span>}
                                                {/* <FormText>upload resolution 1200x1200 pixel</FormText> */}
                                            </FormGroup>
                                        </Col>
                                        <Col size="12">
                                            <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                                <li>
                                                    <Button type="submit" color="primary" size="lg" className="btn-block">
                                                        {form_loading ? (
                                                            <>
                                                                <Spinner size="sm" color="light" /> {modal.edit ? "Updating Group" : "Creating New Group"}
                                                            </>
                                                        ) : (
                                                            <React.Fragment>{modal.edit ? "Update Group" : "Add New Group"}</React.Fragment>
                                                        )}
                                                    </Button>
                                                </li>
                                                <li>
                                                    <a
                                                        href="#cancel"
                                                        onClick={(ev) => {
                                                            ev.preventDefault();
                                                            onFormCancel();
                                                        }}
                                                        className="link link-light"
                                                    >
                                                        Cancel
                                                    </a>
                                                </li>
                                            </ul>
                                        </Col>
                                    </Form>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>

                    {/* delete modal */}
                    <Modal
                        isOpen={modal.delete}
                        toggle={() => setModal({ delete: false })}
                        className="modal-dialog-centered"
                    >
                        <ModalBody className='pt-3 pb-2'>
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">Delete Group{' '}
                                    <Badge color="primary">
                                        {deletingGroup?.name}
                                    </Badge>
                                    {' '}
                                    ?
                                </h5>
                                <div className='mt-2'>
                                    <span>This Item group will be deleted. Do you really want to delete this group ?</span>
                                </div>
                                <div className="mt-3">
                                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4">
                                        <li>
                                            <Button onClick={(e) => {
                                                e.preventDefault();
                                                onFormSubmit();
                                            }} color="danger" className="px-4 btn-block">
                                                {form_loading ? (
                                                    <>
                                                        <Spinner size="sm" color="light" />Deleting
                                                    </>
                                                ) : (
                                                    <React.Fragment>Delete</React.Fragment>
                                                )}
                                            </Button>
                                        </li>
                                        <li>
                                            <a
                                                href="#cancel"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                    onFormCancel();
                                                }}
                                                className="link link-light"
                                            >
                                                Cancel
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>

                    {/* link modal */}
                    <Modal
                        isOpen={modal.link}
                        toggle={() => setModal({ link: false })}
                        className="modal-dialog-centered"
                    >
                        <ModalBody className='pt-3 pb-2'>
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">Add Stores to Group{' '}
                                    <Badge color="primary">
                                        {linkingGroup?.name}
                                    </Badge>
                                </h5>
                                <div className="mt-4">
                                    <Col md="6">
                                        <FormGroup>
                                            <label className="form-label">Store Category</label>
                                            <div className="form-control-wrap">
                                                <Controller
                                                    name="store_category_id"
                                                    control={control}
                                                    render={({ onChange, ref }) => (
                                                        <RSelect
                                                            options={listStoreCategories?.filter((cat) => cat.value === linkingGroup?.store_category_id)}
                                                            onChange={(val) => {
                                                                onChange(val.value)
                                                            }}
                                                            defaultValue={listStoreCategories.find((cat) => cat.value === linkingGroup?.store_category_id)}
                                                        />
                                                    )}
                                                />
                                                {errors.store_id && (
                                                    <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a Category</span>
                                                )}
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md="12">
                                        <FormGroup>
                                            <label className="form-label">Stores</label>
                                            <div className="form-control-wrap">
                                                <RSelect
                                                    id='storeid'
                                                    options={storelinks}
                                                    onChange={(val) => handleChange(val)}
                                                    isMulti
                                                    defaultValue={storelinkdefault}
                                                />
                                                {errors.store_id && (
                                                    <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a Category</span>
                                                )}
                                            </div>
                                        </FormGroup>
                                    </Col>

                                    <Col size="12">
                                        <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                            <li className='mt-3'>
                                                <Button onClick={(ev) => { ev.preventDefault(); linkStoreSubmit() }} color="primary" size="lg" className="btn-block">
                                                    {form_loading ? (
                                                        <>
                                                            <Spinner size="sm" color="light" />Updating Group
                                                        </>
                                                    ) : (
                                                        <React.Fragment>Update Group</React.Fragment>
                                                    )}
                                                </Button>
                                            </li>
                                            <li>
                                                <a
                                                    href="#cancel"
                                                    onClick={(ev) => {
                                                        ev.preventDefault();
                                                        onFormCancel();
                                                    }}
                                                    className="link link-light"
                                                >
                                                    Cancel
                                                </a>
                                            </li>
                                        </ul>
                                    </Col>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                </React.Fragment>
            }
        </React.Fragment>
    )
}

export default ItemGroups
